module.exports = __webpack_public_path__ + "kendoui.a8acbeeeb6bc88ba9658.svg";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/images/kendoui.svg
// module id = ../../../../../external_css/kendo-ui/images/kendoui.svg
// module chunks = styles